import { AutoMessage } from '../../../api/types/messages';
import { Button, ButtonGroup, ListGroup, ListGroupItem, Collapse, Dropdown,DropdownButton } from 'react-bootstrap';
import React, { useState } from 'react';
import { AutoMessageRecipe, fromRecipe } from './Recipes';

interface AutoMessageRecipeSelectorProps {
    recipes?: AutoMessageRecipe[]
    onSelect: (m:Partial<AutoMessage>, forceTemplateType?: string)=>void
}

 export const AutoMessageRecipeSelector: React.FC<AutoMessageRecipeSelectorProps> = (props) => {
    const [open, setOpen] = useState(false);

    if(!props.recipes) {
        return <></>;
    }

    const applyRecipe = (r:AutoMessageRecipe)=> {
        const m = fromRecipe(r.recipe);
        props.onSelect(m, r.forceTemplateType);
    };
   
  return (<>
    <DropdownButton variant="success" title="Apply a recipe" as={ButtonGroup} className="me-1">
      { props.recipes.map((r, i) => <Dropdown.Item key={i} onClick={e=>applyRecipe(r)}>{r.label}</Dropdown.Item>)}
    </DropdownButton>

      <Button onClick={() => setOpen(!open)} aria-controls="automessage-recipes-list" aria-expanded={open}>
        Show recipes
      </Button>
      <Collapse in={open} className="mt-1">
        <ListGroup id="automessage-recipes-list">
        { props.recipes.map((r, i) => <ListGroupItem key={i}>{r.label} <Button onClick={e=>applyRecipe(r)}>Apply this recipe</Button></ListGroupItem>)}
        </ListGroup>
      </Collapse>
    </>
  );
}
